import {
  getChangeLabel,
  isRecalculatedChange,
  withRecalculatedCount,
} from '../../PendingChangesDrawer.utils';

// Like the section header, a sub-group counts its direct changes as changes and reports the recalculated
// values next to them.
export const getSubGroupMetaText = changes => {
  const recalculatedCount = changes.filter(isRecalculatedChange).length;
  const changeCount = changes.length - recalculatedCount;

  return withRecalculatedCount(`${changeCount} ${getChangeLabel(changeCount)}`, recalculatedCount);
};
